module.exports = __webpack_public_path__ + "assets/images/stereo-01.c5d92a0157b1b08a13c1c67af3e55b01.svg";